import { render, staticRenderFns } from "./cooperate.vue?vue&type=template&id=f2c5dbe0&scoped=true"
import script from "./cooperate.vue?vue&type=script&lang=js"
export * from "./cooperate.vue?vue&type=script&lang=js"
import style0 from "./cooperate.vue?vue&type=style&index=0&id=f2c5dbe0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c5dbe0",
  null
  
)

export default component.exports